module.exports = __webpack_public_path__ + "static/media/work-property-people.094d30eb.jpg";